// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"179":"main","757":"game"}[chunkId] + "." + {"179":"7c295317","757":"a1fa4541"}[chunkId] + ".css";
};